<script>
  import Notification from './Item'
  import UserApi from '@/services/Api/UserApi'

  export default {
    components: {
      Notification
    },

    data() {
      return {
        loading: false,
        show_notifications: false,
        notifications: [],
        _user_data_timer: false
      }
    },

    mounted() {
      document.addEventListener('click', this.close)
      this.fetchUserData()
    },

    destroyed() {
      document.removeEventListener('click', this.close)
      clearInterval(this._user_data_timer)
    },

    methods: {
      close() {
        this.show_notifications = false
      },

      fetchUserData() {
        this._user_data_timer = setInterval(() => {
          UserApi.getData()
            .then(data => this.setUserData(data))
        }, 20000)
      },

      setUserData(user_data) {
        this.user.data = user_data
        this.$auth.user(this.user)

        if (user_data.notifications_nb) {
          document.title = '(' + user_data.notifications_nb + ')' + this.$t('title')
        } else {
          document.title = this.$t('title')
        }
      },

      getNotifications() {
        if (this.show_notifications) {
          this.show_notifications = false
          this.$refs.btn1 && this.$refs.btn1.blur()
          this.$refs.btn2 && this.$refs.btn2.blur()
          return
        }

        if (this.loading) {
          return
        }

        this.loading = true
        this.show_notifications = true

        UserApi.getNotifications()
          .then(notifications => (this.notifications = notifications))
          .finally(() => (this.loading = false))

        if (this.user.data.notifications_nb) {
          UserApi.clearNotifications()
            .then(() => {
              this.user.data.notifications_nb = 0
              this.setUserData(this.user.data)
            })
        }
      }
    }
  }
</script>

<template>
  <div
    class="navbar-item has-dropdown"
    :class="{'is-active': show_notifications}">

    <div v-if="!user.data.notifications_nb">
      <a class="button is-light is-flat is-bell"
        ref="btn1"
        @click.prevent.stop="getNotifications">
        <span class="icon">
          <i class="material-icons">notifications</i>
        </span>
      </a>
    </div>
    <!-- has no notifications -->

    <div v-if="user.data.notifications_nb">
      <a class="button is-danger is-flat is-bell"
        ref="btn2"
        @click.prevent.stop="getNotifications">
        {{ user.data.notifications_nb }}
      </a>
    </div>
    <!-- has notifications -->

    <ul class="navbar-dropdown" v-show="show_notifications">
      <li class="is-loader" v-show="loading">
        {{ $t('loading') }}
      </li>
      <li class="is-loader" v-if="!loading && !notifications.length">
        {{ $t('empty') }}
      </li>
      <notification
        v-for="notification in notifications"
        v-show="!loading"
        :key="notification.id"
        :item="notification">
      </notification>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
  @import '~bulma/sass/utilities/all';

  .navbar-dropdown {
    overflow: auto;
    right: -20px;
    left: auto;
    width: 300px;
    max-height: 250px;

    @include touch() {
      width: 100%;
      max-height: 150px;
      margin-top: pxToEm(10);
    }
  }

  .is-loader {
    padding: $size-7;
  }
</style>



// WEBPACK FOOTER //
// List.vue?98d2052e